<template lang="pug">
	.creative-file.flex-col.space-large
		.lr-padding
			FileUploader(v-if="!dataUrl", ref="finalAudioUploader", :text="$tCaption('Upload audio file')", icon="upload", :isLoading="!!isLoading", :isUIHidden="!!dataUrl", 
				@file-selected="fileUploading.selected = true" @upload="onNewCreativeFileUpload", :dropText="$tCaption('Or drop audio files here to upload')")
				.flex-row.space-large.lr-padding(v-if="fileUploading.selected")
					.flex-row.space.align-center
						DxCheckBox(:value.sync="fileUploading.trim", :text="$tCaption('Trim')")
						DxNumberBox(v-show="fileUploading.trim",:value.sync="fileUploading.trimDbLevel", format="#0.## dB", :width="80", :show-spin-buttons="true", :step="0.1")
					.flex-row.space.align-center
						DxCheckBox(:value.sync="fileUploading.normalize", :text="$tCaption('Normalize')")
						DxNumberBox(v-show="fileUploading.normalize", :value.sync="fileUploading.normalizeDbLevel", format="#0.## dB", :width="80", :show-spin-buttons="true", :step="1")
		Waveform(v-if="dataUrl", :src="dataUrl", :opts="{ heightMultiplier: 0.5, color: '#fd9a7a' }", :height="200", @src-load="base64 => $emit('src-load', base64)")
			template(v-for="(_, slot) of $scopedSlots" v-slot:[slot]="{ data }")
				slot(:name="slot" v-bind="data")
		Loader(v-if="isLoading", :text="$tCaption('Processing, please wait') + '..'", :fullscreen="true")
</template>

<script>
	import Waveform from 'app-core/Waveform.vue';
	import storage from 'storage';
	import FileUploader from 'app-core/FileUploader.vue';
	import DxNumberBox from 'devextreme-vue/number-box';
	import DxCheckBox from 'devextreme-vue/check-box';
	import Loader from 'app-core/Loader.vue';

	export default {
		translationCategory: 'creative.CreativeFile',
		name: 'creative-file',
		components: {
			Waveform, FileUploader, DxNumberBox, DxCheckBox, Loader
		},
		props: ['creative', 'creativeDetail'],
		data() {
			return {
				fileUploading: {
					trim: false,
					trimDbLevel: storage.prop('audio-tracker-trim-silence-db-level').value || 0.1,
					normalize: false,
					normalizeDbLevel: storage.prop('audio-tracker-normalize-db-level').value || -3,
					selected: false
				},
				isLoading: false,
				base64: null	
			};
		},
		computed: {
			dataUrl() {
				return this.base64 || this.creative?.FinalAudio?.AzureFileUrl;
			}
		},
		mounted() {
			if (__DEBUG__)
				window.creativeFile = this;
		},
		methods: {
			onNewCreativeFileUpload(v) {
				if (__DEBUG__)
					console.debug('onNewCreativeFileUpload', v);
				var fr = new FileReader;
				fr.readAsDataURL(v[0]);
				fr.onloadend = () => {
					this.onNewBase64FileData(fr.result, v[0].name);
					this.base64 = fr.result;
				};
			},
			onNewBase64FileData(base64, fileName) {
				var audio = new Audio();
				audio.src = base64;
				audio.addEventListener('loadedmetadata', () => {
					var duration = audio.duration;
					var name = `${fileName}`.split('.').slice(0, -1).join('.') || fileName;
					this.creative.Duration = parseFloat(duration * 1000);
					this.$emit('save-creative', this.creative);

					if (__DEBUG__)
						console.debug('Audio locally loaded', { audio, creative: this.creative, base64 });

					var uploadAudio = (creative, base64, customFileName) => {
						return new Promise((mainResolve, mainReject) => {
							if (__DEBUG__)
								console.debug('Upload creative audio', { base64 });
							var toolPromise = (method, dbLevel, condition, audioBase64) => new Promise(resolve => {
								if (condition) {
									var data = audioBase64.split(';base64,')[1];
									var ext = this.$Data.getBase64AudioExtension(audioBase64);
									this.isLoading++;
									this.$Data.postExternalApi(`audio/${method}`, {
										MediaExtension: ext,
										DbLevel: dbLevel,
										Base64Content: data
									}, {
										xhr: () => {
											var xhr = new XMLHttpRequest();
											xhr.responseType= 'blob';
											return xhr;
										},
										processData: false,
										dataType: 'binary'
									}).then(r => {
										if (r.Success !== false) {
											var fr1 = new FileReader;
											fr1.onloadend = () => {
												if (__DEBUG__)
													console.debug(`${method} result on file upload`, { r: fr1.result });
												resolve(fr1.result);
											};
											fr1.readAsDataURL(r);
										} else {
											resolve(audioBase64);
										}
									}).catch(() => {
										resolve(audioBase64);
									}).finally(() => this.isLoading--);
								} else {
									resolve(audioBase64);
								}
							});

							toolPromise('TrimAudio', this.fileUploading.trimDbLevel, this.fileUploading.trim, base64).then(r1 => {
								toolPromise('NormalizeAudio', this.fileUploading.normalizeDbLevel, this.fileUploading.normalize, r1).then(r2 => {
									this.isLoading++;
									this.$azure.uploadCreativeFinalAudio(this.creative, r2, customFileName)
										.then((r3) => {
											mainResolve(r3);
											if (__DEBUG__)
												console.debug('Final audio creative uploaded', { r2 });
										})
										.catch((ex) => {
											mainReject(ex);
										})
										.finally(() => this.isLoading--);
									return r2;
								});
								return r1;
							});
						});
					};

					this.isLoading++;
					uploadAudio(this.creative, base64, name).catch(ex => this.$notifyError(ex)).finally(() => this.isLoading--);
				}, false);
			}
		}
	};
</script>
<style lang='scss'>
	.creative-file {
		.lr-padding {
			padding: 0px 30px !important;
		}
	}
</style>
